import { ActionTypes } from '../types/actionTypes';
import {
  ISetEtpRegistrationInn,
  ISetEtpRegistrationSearchResult,
  ISetETPRegistrationLoading,
  ISetETPRegistrationErrors,
} from '../types/actions';
import { IEtpOrganization } from '../types/interfaces';

interface IEtpRegistrationState {
  inn: string[];
  searchResult: IEtpOrganization[];
  isLoading: boolean;
  errors: string;
}

const initialState = {
  inn: [],
  searchResult: [],
  isLoading: false,
  errors: '',
} as IEtpRegistrationState;

export type TEtpRegistration =
  | ISetEtpRegistrationInn
  | ISetEtpRegistrationSearchResult
  | ISetETPRegistrationLoading
  | ISetETPRegistrationErrors;

export default function etpRegistration(state = initialState, action: TEtpRegistration) {
  switch (action.type) {
    case ActionTypes.SET_ETP_REGISTRATION_INN:
      return { ...state, inn: [...state.inn, action.payload] };
    case ActionTypes.SET_ETP_REGISTRATION_SEARCH_RESULT:
      return { ...state, searchResult: action.payload };
    case ActionTypes.SET_ETP_REGISTRATION_LOADING:
      return { ...state, isLoading: action.payload };
    case ActionTypes.SET_ETP_REGISTRATION_ERRORS:
      return { ...state, errors: action.payload };

    default:
      return state;
  }
}
